export const ADD_CONNECTION_SUCCESS = 'ADD_CONNECTION_SUCCESS'
export const ADD_CONNECTION_FALIURE = 'ADD_CONNECTION_FALIURE'
export const ADD_CONNECTION_FETCH = 'ADD_CONNECTION_FETCH'
